/** Format and calendar helpers for the account System Settings timezone. */

export function resolveTimeZone(tz) {
  const s = (tz || "").trim();
  return s || "UTC";
}

/** YYYY-MM-DD of an instant in the given IANA timezone. */
export function ymdInTimeZone(date = new Date(), timeZone = "UTC") {
  const tz = resolveTimeZone(timeZone);
  try {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date instanceof Date ? date : new Date(date));
  } catch {
    return new Date(date).toISOString().slice(0, 10);
  }
}

/** Default report range: last N calendar days in account TZ (inclusive). Default = today only. */
export function defaultDateRangeForTz(timeZone = "UTC", days = 1) {
  const tz = resolveTimeZone(timeZone);
  const n = Math.max(1, Number(days) || 1);
  const to = ymdInTimeZone(new Date(), tz);
  // Walk back ~n days in UTC then re-format in TZ (good enough for UI defaults)
  const fromDate = new Date();
  fromDate.setUTCDate(fromDate.getUTCDate() - (n - 1));
  const from = ymdInTimeZone(fromDate, tz);
  return { dateFrom: from, dateTo: to };
}

/**
 * Format an ISO/UTC instant in the account timezone.
 * Falls back to browser local if tz is missing/invalid.
 */
export function formatInTimeZone(iso, timeZone, opts = {}) {
  if (!iso) return "—";
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const tz = resolveTimeZone(timeZone);
  const {
    dateStyle = "short",
    timeStyle = "short",
    hour12,
  } = opts;
  try {
    return new Intl.DateTimeFormat(undefined, {
      timeZone: tz,
      dateStyle,
      timeStyle,
      ...(hour12 === undefined ? {} : { hour12 }),
    }).format(d);
  } catch {
    return d.toLocaleString();
  }
}

/** Prefer server-provided display string, else format with account TZ. */
export function formatReportTime(isoOrDisplay, timeZone, display) {
  if (display) return display;
  return formatInTimeZone(isoOrDisplay, timeZone);
}
